import { resourceText } from 'src/app/shared/services/localization';
import { formatDate, Location } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { TenantService } from 'src/app/tenant/tenant.service';
import { MemberSearch } from '../member-search/member-search.model';
import { MemberSearchService } from '../member-search/member-search.service';
import { GetPlannedFollowup } from '../models/getPlannedFollowup.model';
import { FollowupService } from '../services/followup.service';
import { GlobalService } from '../services/global.service';
import { IdentityService } from '../services/identity.service';
import { MemberService } from '../services/member.service';
import { OutreachSelection } from '../outreach/outreach-selection';

@Component({selector:'app-user-task',templateUrl:'./user-task.component.html',styleUrls:['./user-task.component.scss','../outreach/outreach.scss'],standalone:false})
export class UserTaskComponent implements OnInit, OnChanges {
 @Input() user:MemberSearch;
 @Input() plansArr:GetPlannedFollowup[];
 @Input() event:string;
 @Input() applyRefresh=false;
 completingTask=false; step=0; error=''; savedCount=0; timeZone=0;
 seedMemberIds:number[]=[]; selection:OutreachSelection;
 constructor(public globalService:GlobalService,public identityService:IdentityService,private memberService:MemberService,
  private _router:Router,public memberSearchService:MemberSearchService,private _location:Location,
  private tenantService:TenantService,private followupService:FollowupService,private changeDetectorRef:ChangeDetectorRef){}
 ngOnInit(){this.timeZone=this.globalService.timeZone;}
 ngOnChanges(changes?:SimpleChanges){
  if(!this.user)return;
  if(this.seedMemberIds[0]===this.user.memberId && changes && !changes.event && !changes.user)return;
  this.seedMemberIds=[this.user.memberId];this.selection=null;this.step=0;this.error='';this.savedCount=0;
  const eventActivity=this.GetActivityValue(this.event);
  this.user['activity']=eventActivity>=0?eventActivity:(this.user['activity']>=0?this.user['activity']:0);
  this.user['status']=1;
  this.user['actualDate']=formatDate(new Date(),'yyyy-MM-dd','en');
  this.user['timeStr']=formatDate(new Date(),'HH:mm','en');
 }
 get canContinue(){return !!this.selection?.ready&&this.selection.memberIds.length>0;}
 get detailsValid(){return Number.isInteger(this.user?.['activity'])&&this.user['activity']>=0&&this.user['activity']<=3&&
  [0,1,2].includes(this.user['status'])&&!!this.user['actualDate']&&!!this.user['timeStr']&&
  !isNaN(new Date(this.user['actualDate']+'T'+this.user['timeStr']).getTime());}
 next(){if(this.completingTask)return;if(this.step===0&&this.canContinue)this.step=1;else if(this.step===1&&this.canContinue&&this.detailsValid)this.step=2;}
 cancel(){if(this.completingTask)return;this.user.confirmView=false;this.user.editView=false;this.step=0;}
 GetActivityValue(event:string){return ['Visit','Call','Text','Email'].indexOf(event);}
 activityLabel(){return ['VISIT','CALL','TEXT','EMAIL'][this.user?.['activity']]||'TASK';}
 statusLabel(){return ['PLANNED','COMPLETE','DENIED'][this.user?.['status']]||'STATUS';}
 async CompleteTask(user:MemberSearch){
  if(this.completingTask||this.step!==2||!this.canContinue||!this.detailsValid)return;
  this.completingTask=true;this.error='';
  let saved=false;
  try{
   const date=new Date(user['actualDate']+'T'+user['timeStr']);
   const existing=this.plansArr?.find(plan=>plan.id===user['taskId']);
   this.savedCount=await this.followupService.saveOutreach({seedMemberIds:[...this.seedMemberIds],memberIds:[...this.selection.memberIds],
    isRecording:true,assignees:[this.identityService.memberId],existingTaskId:existing?.id,
    activity:{activity:user['activity'],status:user['status'],planDate:date,actualDate:date,assigneeComment:user['assigneeComment']||'',assignerComment:''}});
   saved=true;user.confirmView=false;user.editView=false;this.step=0;
  }catch{this.error=resourceText('OUTREACH_SAVE_FAILED');}
  finally{this.completingTask=false;this.changeDetectorRef.markForCheck();}
  if(saved&&this.applyRefresh){try{await this.loadTasks();}catch{this.error=resourceText('OUTREACH_REFRESH_FAILED');}finally{this.changeDetectorRef.markForCheck();}}
 }
 async loadTasks(){
  this.plansArr=await this.followupService.GetFollowupByAssignee(this.identityService.memberId);
  this.memberSearchService.searchResult=await this.memberSearchService.AdvancedSearch(this.memberSearchService.filter,'pageNumber=1&pageSize=20',true);
  this.memberSearchService.memberArr=this.memberSearchService.memberArr.filter(member=>this.plansArr.some(plan=>plan.memberId===member.memberId));
  this.populatePlans();
 }
 populatePlans(){
  this.memberSearchService.memberArr.forEach(member=>{
   const plan=this.plansArr.find(p=>p.memberId===member.memberId);if(!plan)return;
   Object.assign(member,{taskId:plan.id,confirmView:false,editView:false,activity:plan.activity,activityStr:plan.activityStr,
    planDate:formatDate(plan.planDate,'yyyy-MM-dd','en'),actualDate:formatDate(plan.actualDate,'yyyy-MM-dd','en'),assigner:plan.assigner,
    assignerComment:plan.assignerComment,assignee:plan.assignee,assigneeComment:plan.assigneeComment,status:1,createdBy:plan.createdBy,creationDate:plan.creationDate});
  });
 }
}
